import React, { useState, useEffect, useCallback, useContext } from "react";
import {
  View,
  StyleSheet,
 // KeyboardAvoidingView,
  Platform,
  //Keyboard,
 // TextInput,
 // ScrollView,
  //FlatList,
 // TouchableOpacity,
  //Image,
} from "react-native";
//import { useFocusEffect } from '@react-navigation/native';
//import { Image } from "react-native-expo-image-cache";
// import { MaterialCommunityIcons, 
//          AntDesign, 
//          Fontisto, 
//          Octicons, 
//          FontAwesome5, 
//          Entypo  } from "@expo/vector-icons";
// import * as ImagePicker from "expo-image-picker"
// import * as ImageManipulator from "expo-image-manipulator";
import * as DocumentPicker from 'expo-document-picker'


import colors from "../config/colors";
import Text from "../components/Text";
// import { TouchableWithoutFeedback } from "react-native-gesture-handler";
import dateNow from "../utility/dateNow";
//import useAuth from "../auth/useAuth";
//import routes from "../navigation/routes";
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
// import CardSeed from "../components/CardSeed";
// import defaultStyles from "../config/styles";
// import { Video, AVPlaybackStatus } from 'expo-av';

 

import VideoVisor from "../components/VideoVisor";
import ActivityIndicator from "../components/ActivityIndicator";
import PickerActionsScreen from "./PickerActionsScreen";
import CardEdit from "../components/CardEdit";
import AuthContext from "../auth/context";


const webUrl = connectionConfig.imageUrl + '/seedImages/'

var pointer = 0
var blockSize = 30
var pageNumber = 0
var arrayActions = []
//var content = []
var date = dateNow()
let newSeedId = 0
var indexLike = 0
var pickSeedId = 0
var changeListing = true
var type = 0
var typeFileImageAndVideo = ''
var nameDateImageAndVideo = ''
var typeFile = ''
var nameDateDoc = ''
var seedId = 0
var prueba19julCount = 0
var origin = 0
//var content = []

//var listing = []
//let newSeedPath = []

function ActionComponentScreen({ navigation, route, props, type, seedId, origin, changeListing  }) {
  //debugger
  //const [newSeedId, setNewSeedId] = useState(0);
  const [newPath, setNewPath] = useState(0);
  const [showActions, setShowActions] = useState("Show Actions");
  //const [count, setCount] = useState(0)

  const { user } = useContext(AuthContext)
  
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listing, setListing] = useState([]);
  const [content, setContent] = useState([]);

  const [ titleBoxText, setTitleBoxText ] =  useState('') // para que jale el comentario
  const [ descriptionBoxText, setDescriptionBoxText ] =  useState('') // para que jale el comentario 
  const [imageUri, setImageUri] = useState('');
  const [pickerFile, setPickerFile] = useState(null);
  const [videoNumber, setVideoNumber] = useState(''); // Link de video de youtube 
  const [youtubeLink, setYoutubeLink] = useState(''); // Id de video de youtube extraído del link mediante método onChangeText

  var userId = JSON.parse(user).userId;
  var foundUserChecker = route.params.foundUserChecker

  const video = React.useRef(null);


  const HEIGHT = 315.2727355957031
  //(Dimensions.get('window').height) * .5;
  
  const sizeItemLayout = ( item, index) => (
    {length: HEIGHT, offset: HEIGHT * index, index}
  );

  // function actualizaNewSeed () {
  //   pathSeed()
  //   console.log("actualiza newSeed")
  //   console.log(count) 
  //   setCount(count+1)
  // }

  useEffect(() => {
    //debugger
    console.log("seedId ", route.params.seedId, "type ", route.params.type)
      renderActionOrComment()
      console.log("Actioncomponentscreen Type: ", type)
      //console.log( "content despues de post renderActionOrComment")
      //console.log(content)
      date = dateNow()
      //setListing(route.params); 
      //type = {type}
      //seedId = {seedId}
      //origin = {origin}
  }, [route.params.seedId]);

  type = route.params.type
  seedId = route.params.seedId
  origin = route.params.origin





//----------------------------------------------------------------------------
// Servicio para buscar un navegador de archivos del celular para buscar un pdf 
//   (Esta función es para seleccionar el documento)
//----------------------------------------------------------------------------
const uploadDocument = async () => {
  var options = {
    type: 'image/png'
  }
  if (Platform.OS === 'android') {
 
    options = {
    
      copyToCacheDirectory: true,
      multiple: false
    }
  } else {
    options = {
      copyToCacheDirectory : true,
     
      multiple: false
    }
  }
  try {
    if (Platform.OS === 'android') {
      await DocumentPicker.getDocumentAsync(options)
      .then(res => {
       // debugger
       if (res.type === 'cancel') {
        setPickerFile(null);
 
       } else {
        setPickerFile(res);
       }
        console.log('res : ' + JSON.stringify(res));
        console.log('User cancelled file picker->', res);
        console.log(res.uri, res.type, res.name, res.size)
 
      })
    } else {
      await DocumentPicker.getDocumentAsync(options)
      .then(res => {
       // debugger
       if (res.type === 'cancel') {
        setPickerFile(null);
 
       } else {
        setPickerFile(res);
       }
        console.log('res : ' + JSON.stringify(res));
        console.log('User cancelled file picker->', res);
        console.log(res.uri, res.type, res.name, res.size)
 
      })
      
    }
    
  } catch (err) {
    setPickerFile(null);
   
      alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
  }
 }
 

//----------------------------------------------------
//   Función para extraer el Id del link de Youtube
//----------------------------------------------------
// "https://www.youtube.com/watch?v=WWzEK7NLi74youTubeUrl"
//  const videoNumber = ("WWzEK7NLi74");
const onChangeText = async () => {
  setYoutubeLink(videoNumber)
 console.log(youtubeLink)
 //setCountPasteYoutube(countPasteYoutube+1)

 // if(countPasteYoutube<=1){
 //   setYoutubeLink(text)
 //   setCountPasteYoutube(countPasteYoutube+1)
 
     try {
       let re = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
       const id = youtubeLink.match(re)[7];
       setVideoNumber(id)
       console.log(id)
       console.log(videoNumber)
       //if(!id === '')
       //setVideoNumber(id)
       //console.log(videoNumber)
     } catch (error) {
       console.log("error en el link de Youtube", error) 
     }
   
} 



//----------------------------------------------------------------------------------------
//  Función para traer la info de la acción o contenido para su edición a agregar una más. 
//----------------------------------------------------------------------------------------
const renderActionOrComment = async () => {
  //console.log("Entre a renderActionOrComment, content es... seedId es...", content, " ", seedId)
  var post_values = {
    seedId: seedId
    //seedId: newSeedId
   }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/selectActionFromFlatlist/', configurationPost)
  .then(response => response.json())
  .then(response => { 
   //debugger
   //var item = []
   //var item = response     //response.data
   setContent(response)
   //setItems(response)
   console.log("saliendo de renderActionOrComment, content es... ", content)
   setLoading(false)
   changeListing = true
   //var screen = 'ActionScreen'
   //navigation.navigate(routes.SEED_DETAILS, { item, screen, changeListing } ) 
  })
  .catch(err =>{
  console.log(':( review internet service /selectActionFromFlatlist/', err )
  })

}

{/* <View backgroundColor={colors.pistache}>
<Text onPress={()=>renderActionOrComment()}
> Press </Text>
<CardEdit
type={type}  
seedId={seedId}
origin={origin}
/>
</View> */}

 
    return (

      <View backgroundColor={colors.pistache}>
      <Text onPress={()=>renderActionOrComment()}
      > Press {seedId}</Text>
     
     {
   
   content.type === 0 ?
   <CardEdit
   type={content.type}  
   title={content.seedName}
   seedDescription={content.seedDescription}
   seedId={content.seedId}
   seedName={content.seedName} 
   seedPhoto={content.seedPhoto}
   origin={content.origin}
   videoNumber={content.youtubeId}
   documentSeed={content.documentSeed} 
   userId={userId}
   navigation = {navigation}
   imageUrl={
     content.seedPhoto.includes('.mp4') ?
     seedVideoUri + content.seedPhoto :
     content.seedPhoto.includes('.mov') ?
     seedVideoUri + content.seedPhoto :
     webUrl + content.seedPhoto}
   thumbnailUrl={webUrl + userId + '_' + content.seedPhoto}
/>
   :
   null
 }

      </View> 
      
);     
}

const styles = StyleSheet.create({
  pruebaflat: {
    height: 300,
    backgroundColor: "green",
      },
  prueba: {
height: 200,
backgroundColor: "red",
  },
  containerYoutubeLink: {
    width: "100%",
    //height: "6%",
    //fontSize: 18,
    //color: colors.black,
    //borderWidth: 1,
    marginTop: "2%",
    marginLeft: "2%",
    //padding: "2%", 
    flexDirection:"row",
    //justifyContent: 'space-evenly',
    backgroundColor: '#00000000', // Le puse este color esperando se vuelva transparente '#00000000',
    //backgroundColor: "red",
    //borderRadius: 30,
  },
  containerTitleDescription:{
    marginTop:"5%",
    width:"100%",
    //height:"10%"
},  
  input: {
    width: "80%",
    fontSize: 18,
    color: colors.black,
    borderWidth: 1,
    marginTop: "2%",
    marginLeft: "2%",
    padding: "2%", 
  },
  inputYoutube: {
    width: "80%",
    fontSize: 18,
    color: colors.black,
    borderWidth: 1,
    marginTop: "2%",
    marginLeft: ".3%",
    padding: "2%", 
    //backgroundColor: "red",
  },
  imagePhoto: {
    width: 200,
    height: 200,
    alignSelf: "center",
    marginBottom: "10%",
    borderRadius: 5,
    marginTop: "5%",
  },
  icon:{
    alignSelf:"center",
    marginTop: "7%",
    width:"100%",
},
iconPlay:{
  alignSelf:"center",
  alignContent: "center",
  marginTop: "1%",
  marginLeft: "1%",
  marginRight: "85%",
},
iconYoutube:{
  zIndex: 2,
  justifyContent: 'center', // Esto hace que las imágenes se centren verticalmente no importando que tanto crezca el texto.
  alignSelf:"center",
  padding: "1%",
  backgroundColor: colors.light,
  marginRight: "5%",
  marginLeft: "-1.5%",
  marginTop: "2%",
},
//----------------------------------------------------
  detailsContainer: {     //Contenedor de primera línea botones
    marginLeft: "3%",
    padding: "2%",
    flexDirection: "row",
    width: "92%",
    height: "25%",
    //backgroundColor: "red",
  },
  generals: {
    marginTop: "2%",
    marginLeft: "4%",
    width: "92%",
    //height: "25%", 
  },
  image: {
    marginTop: "1%",
    marginLeft: "2%",
    width: 182,
    height: 182,
   // borderRadius: 2,

  },
  treeFollowersIconsContainer: {
    marginTop: "1%",
    marginLeft: "5%",
    //flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
    //height: "20%",
    backgroundColor: colors.pistache,
  },
  tree:{
    marginLeft: "10%",
    color: colors.dark,
    marginTop: "2%",
   },
   textFollowers: {
    color: colors.medium,
    fontWeight: "900",
    marginTop: "2%",
    marginLeft: "6%",
   },
  //  numbersActionsFollowers: {
  //   color: colors.dark,
  //   marginTop: "2%",
  //  },
  //  numbersFollowers: {
  //   color: colors.dark,
  //   marginTop: "-2%",
  //   marginBottom: "2%",
  //  },
  // description: {
  //   color: colors.greyDescription,
  //   fontSize: 17,
  //   marginRight: "2%",
  //   marginLeft: "2%",
  //   marginTop: "1%",
  //   textAlign: "justify",
  //   backgroundColor: "yellow",
  // },
  video: {
    width: "90%",
    height: "20%",
    marginTop: "2%",
    marginLeft: "5%",
    backgroundColor: colors.pistache,
  },
  // seedTitle:{
  //   marginTop: "1%",
  //   width: "100%", 
  //   alignItems: 'center',
  //   backgroundColor: colors.chakra0red,
  // },
  // seedTitle1:{
  //   marginTop: "1%",
  //   width: "100%", 
  //   alignItems: 'center',
  //   backgroundColor: colors.chakra1nar,
  // },
  // seedTitle2:{
  //   marginTop: "1%",
  //   width: "100%", 
  //   alignItems: 'center',
  //   backgroundColor: colors.chakra2ama,
  // },
  // seedTitle3:{
  //   marginTop: "1%",
  //   width: "100%", 
  //   alignItems: 'center',
  //   backgroundColor: colors.chakra3ver,
  // },
  // seedTitle4:{
  //   marginTop: "1%",
  //   width: "100%", 
  //   alignItems: 'center',
  //   backgroundColor: colors.chakra4azu,
  // },
  // seedTitle5:{
  //   marginTop: "1%",
  //   width: "100%", 
  //   alignItems: 'center',
  //   backgroundColor: colors.chakra5vlt,
  // },
  // seedTitle6:{
  //   marginTop: "1%",
  //   width: "100%", 
  //   alignItems: 'center',
  //   backgroundColor: colors.chakra6rsa,
  // },
  // seedTitle7:{
  //   marginTop: "1%",
  //   width: "100%", 
  //   alignItems: 'center',
  //   backgroundColor: colors.chakra7ryo,
  // },
  // seedTitle8:{
  //   marginTop: "1%",
  //   width: "100%", 
  //   alignItems: 'center',
  //   backgroundColor: colors.chakra8tur,
  // },
  // seedTitle9:{
  //   marginTop: "1%",
  //   width: "100%", 
  //   alignItems: 'center',
  //   backgroundColor: colors.chakra9aur,
  // },


  title: {
    color: colors.dark,
    //fontWeight: "bold",
    textAlign: "justify",
    fontSize: 18,
    marginTop: "2%",
    width: "90%",
    fontWeight: "500",
    textAlign: "justify",
  },
  buttonsContainersContainer: {
    //padding: 25,
    width: "100%",
    height: "50%",
    //justifyContent: 'center',
    marginVertical: 10,
    //alignItems: "center",
    //textAlign: "center",
  },
  // ContainerButtonEdit: {
  //   marginTop: "9%",
  //   height: "15%",
  // },
  // buttonEdit: {
  //   marginLeft: "2%",
  //   backgroundColor: colors.primary,
  //   justifyContent: "center",
  //   alignItems: "center",
  //   padding: 4,
  //   marginRight: "5%",
  // },
  // textEdit: {
  //   color: colors.white,
  //   fontSize: 18,
  // },
  buttonsContainer1: {
    paddingLeft: "12%",
    flexDirection: "row",
    width: "100%",
    height: 50,
    marginVertical: 10,
    alignItems: "center",
    alignContent: "center",
  },
  buttonsContainer2: {
    padding: 7,
    flexDirection: "row",
    width: "100%",
    height: 50,
    marginVertical: 10,
    alignItems: "center",
  },
  buttonsContainer3: {
    paddingLeft: "12%",
    padding: 7,
    flexDirection: "row",
    width: "100%",
    height: 50,
    marginVertical: 10,
    alignItems: "center",
  },
  bottomMenu: {
    //paddingLeft: "12%",
    //padding: 7,
    flexDirection: "row",
    alignSelf: "flex-end",
    width: "100%",
    height: "10%",
    //marginVertical: 10,
    //alignItems: "center",
    backgroundColor: colors.fuente,
  },
      

    // ********************* Inicia css de la semilla o accion original. **************************
    detailsContainerSeed: {     //Contenedor de primera línea botones
      flexDirection: "row",
      width: "100%",
      //backgroundColor: "green",
      overflow: "hidden",
    },
    imageSeed: {
      marginTop: "1%",
      marginBottom: "1%",
      marginLeft: "2%",
      width: 250,
      height: 250,
      backgroundColor: "green",
    },
    imageVideoSeed: {
      width: 250,
      height: 250,
      //flexDirection:"row",
      alignSelf: "center",
      alignItems: "center",
      //backgroundColor: "blue",
      //marginTop: 50,
      //marginBottom: 50,
      //borderRadius: 5,
    },
    treeFollowersIconsContainer: {
      marginTop: "2%",
      marginBottom: "1%",
      marginLeft: "2%",
      //flexDirection: "row",
       alignItems: "center",
      // alignContent: "center",
      //height: "20%",
      backgroundColor: colors.pistache,
    },
    treeSeed:{
      marginLeft: "10%",
      //color: colors.dark,
      color:  "green",
      marginTop: "2%",
     },
     textFollowers: {
      //color: colors.medium,
      color: colors.green,
      fontWeight: "900",
      marginTop: "2%",
      marginLeft: "6%",
     },
     numbersActionsFollowers: {
      color: colors.dark,
      marginTop: "4%",
     },
     numbersFollowers: {
      color: colors.dark,
      marginTop: "-2%",
      marginBottom: "2%",
     },
    viewDescription: {
      marginTop: "1%",
      marginLeft: "4%",
      width: "92%",
      //height: "25%", 
    }, 
    description: {
      color: colors.greyDescription,
      //fontWeight: "bold",
      fontSize: 17,
      //marginVertical: 10,
      marginRight: "2%",
      marginLeft: "2%",
      marginTop: "1%",
      textAlign: "justify",
      backgroundColor: "yellow",
    },
    seedTitle:{
      marginTop: 1,
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra0red,
      //backgroundColor: "blue",

    },
    seedTitle1:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra1nar,
    },
    seedTitle2:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra2ama,
    },
    seedTitle3:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra3ver,
    },
    seedTitle4:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra4azu,
    },
    seedTitle5:{
      marginTop: "1%",
      width: "100%", 
     //alignItems: 'center',
      backgroundColor: colors.chakra5vlt,
    },
    seedTitle6:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra6rsa,
      //pink
    },
    seedTitle7:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra7ryo,
    },
    seedTitle8:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra8tur,
    },
    seedTitle9:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra9aur,
    },
    titleSeed: {
      color: colors.dark,
      //fontWeight: "bold",
      textAlign: "justify",
      fontSize: 18,
      marginTop: "2%",
      width: "90%",
      fontWeight: "500",
      textAlign: "justify",
      //backgroundColor: "green",

    },
    ContainerButtonEdit: {
      marginTop: "9%",
      height: 35,  // Esta madre la tenía en porcentaje y me estaba generando un fantasma en blanco¡¡ Recuerda no usar ningún heght en porcentaje¡¡¡¡ no mameeees 6 horas perdidas me carga la chi....
      width: "75%",
    },
    buttonEdit: {
      marginLeft: "2%",
      backgroundColor: colors.primary,
      borderRadius: 15,
      justifyContent: "center",
      alignItems: "center",
      padding: 4,
      marginRight: "5%",
    },
    textEdit: {
      color: colors.white,
      fontSize: 18,
    },
    imageMountainSeed: {
      //width: "100%",
      //height: 250,
      alignItems: "center",
      backgroundColor: "green",
    },
  // **** Aqui termina todo el css de la semilla


});

export default ActionComponentScreen;
